import { getCookies } from './cookies.js';
const MF_SERVER_COOKIE = 'CRYSTAL_MF_SERVER';
/**
 * Converts a package of name '@my-mf/hello-world' and version '1.0.0-experimental.1' to 'my-mf_hello-world/1.0.0-experimental.1'
 */
export function getMfId({ name, version, config }) {
    if (config?.mfId) {
        return config.mfId;
    }
    const mfName = name.replace('@', '').replaceAll('/', '_');
    return `${mfName}/${version}`;
}
/**
 * Package '@crystal-demo/hello-team' with version '1.0.0-experimental.1' becomes 'crystal-demo_hello-team/1.0.0-experimental.1'
 */
export function getFrontendId(name, version, config) {
    return getMfId({ name, version, config });
}
export const getMfInstanceId = (mfId, instanceId) => (instanceId ? `${mfId}-${instanceId}` : mfId);
export class ContainerElement {
    constructor(mfId, instanceId) {
        this.mfInstanceId = getMfInstanceId(mfId, instanceId);
        this.selector = `div[data-mf-id="${this.mfInstanceId}"][data-mf-role="container"]`;
    }
    attrs() {
        return {
            'data-mf-id': this.mfInstanceId,
            'data-mf-role': 'container',
        };
    }
    query() {
        return document.querySelector(this.selector);
    }
}
export class PlaceholderElement {
    constructor(mfId, instanceId) {
        this.mfId = mfId;
        this.mfInstanceId = getMfInstanceId(mfId, instanceId);
        this.selector = `div[data-mf-id="${this.mfInstanceId}"][data-mf-role="placeholder"]`;
    }
    attrs() {
        return {
            'data-mf-id': this.mfInstanceId,
            'data-mf-role': 'placeholder',
        };
    }
    query() {
        return document.querySelector(this.selector);
    }
    queryAll() {
        return document.querySelectorAll(`div[data-mf-id|="${this.mfId}"][data-mf-role="placeholder"]`);
    }
}
PlaceholderElement.selector = `div[data-mf-id][data-mf-role="placeholder"]`;
PlaceholderElement.id = 'data-mf-id';
export class PropsData {
    constructor(mfId, instanceId) {
        this.mfInstanceId = getMfInstanceId(mfId, instanceId);
        this.selector = `script[data-mf-id="${this.mfInstanceId}"][data-mf-role="data"]`;
    }
    attrs() {
        return {
            'data-mf-id': this.mfInstanceId,
            'data-mf-role': 'data',
            type: 'application/json',
        };
    }
    query() {
        return document.querySelector(this.selector);
    }
}
export class BootstrapScript {
    constructor(mfId, instanceId) {
        this.mfInstanceId = getMfInstanceId(mfId, instanceId);
        this.selector = `script[data-mf-id="${this.mfInstanceId}"][data-mf-role="bootstrap"]`;
    }
    attrs() {
        return {
            'data-mf-id': this.mfInstanceId,
            'data-mf-role': 'bootstrap',
        };
    }
    query() {
        return document.querySelector(this.selector);
    }
    queryAll() {
        return document.querySelectorAll(this.selector);
    }
}
export function getMfServerCookie(key) {
    const cookies = getCookies();
    const suffix = key ? `_${key}` : '';
    return cookies[`${MF_SERVER_COOKIE}${suffix}`];
}
export function getMfServerOverride(mfServer, { mfId = '', preventOverride = false } = {}) {
    if (preventOverride) {
        return mfServer;
    }
    return getMfServerCookie('') || getMfServerCookie(mfId) || mfServer;
}
//# sourceMappingURL=mf-utils.js.map